import { SiteLocale } from '.generated/dato'

type Item = {
  _allSlugLocales:
    | {
        __typename?: 'StringNonNullMultiLocaleField' | undefined
        locale: SiteLocale | null
        value: string
      }[]
    | null
}

export function getSlugTranslations({
  items,
  sourceLocale,
  slug,
  targetLocale,
}: {
  items?: Item[] | null
  sourceLocale: 'de' | 'en'
  slug: string
  targetLocale: 'de' | 'en'
}) {
  return items
    ?.find((blogPost) =>
      blogPost._allSlugLocales?.find(
        (slugLocale) =>
          slugLocale.locale === sourceLocale && slugLocale.value === slug,
      ),
    )
    ?._allSlugLocales?.find((slugLocale) => slugLocale.locale === targetLocale)
    ?.value
}
